/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { localizationStrSchema } from "./localizationStrSchema.ts";
import { shapeEnumSchema } from "./shapeEnumSchema.ts";

export const badgeSchema = z.object({
	key: z
		.string()
		.max(50)
		.regex(/^[-a-zA-Z0-9_]+$/)
		.describe("Латиница, цифры, дефис и подчёркивание. Уникален в рамках точки (например, new, hit)."),
	label: z.string().max(15).describe("Не более 15 символов — столько влезает в плашку на карточке блюда."),
	priority: z
		.int()
		.min(0)
		.max(2147483647)
		.optional()
		.describe("Порядок показа на карточке блюда: чем меньше, тем важнее. На точке не может быть двух тегов с одинаковым приоритетом."),
	shape: shapeEnumSchema
		.optional()
		.describe("* `pill` - Пилюля\n* `ribbon` - Лента\n* `sticker` - Наклейка\n* `icon_only` - Только иконка\n* `inherit` - Как у всех"),
	bg_color: z
		.string()
		.max(7)
		.regex(/^#[0-9a-fA-F]{6}$/)
		.optional()
		.describe("HEX-код фона плашки."),
	icon_color: z
		.string()
		.max(7)
		.regex(/^#[0-9a-fA-F]{6}$/)
		.optional()
		.describe("HEX-код текста и иконки на плашке."),
	icon: z.string().nullable(),
	active_from: z.iso.datetime().nullish().describe("Пусто — тег показывается сразу. Время уходит на фронт, скрывает тег он сам."),
	active_until: z.iso.datetime().nullish().describe("Пусто — тег показывается бессрочно. Время уходит на фронт, скрывает тег он сам."),
	loc_label: localizationStrSchema.describe("Util serializer for representation in swagger"),
});
